import { createReducer, on } from '@ngrx/store';
import {
  ActiveComponentChanged,
  ResetStateFromRouter,
} from 'src/app/shared/actions/eliqua.actions';
import {
  FlowContextChanged,
  FlowNameChanged,
  MarkActiveChanged,
  ResetClearJsonData,
  ResetJsonData,
  UpdateJsonData,
  UpdateJsonDataSimple,
  ValidateJSON,
  ValidateJSONSuccess,
} from '../actions/edit-flow.actions';
import { GetFlowsSuccess, GetLanguagesSuccess } from '../actions/search-flows.actions';
import { CloseSidenav, EditFlow, ViewFlow } from '../actions/sidenav.actions';
import { EditFlowState } from '../models/flows.model';

const initialState: EditFlowState = {
  initialRoutes: [
    'MEMBER-EVENT-START',
    'LOYALTY-TRANSACTION-START',
    'CUSTOMER-FLOW-START',
    'TRANSACTION-START',
    'TICKET-FLOW-START',
    'CUSTOMER-FLOW-START',
    'COUPON-EVENT-START',
    'MEMBER-EVENT-END',
    'LOYALTY-TRANSACTION-END',
    'CUSTOMER-FLOW-END',
    'TRANSACTION-END',
    'TICKET-FLOW-END',
    'CUSTOMER-FLOW-END',
    'COUPON-EVENT-END',
    'MERCHANT-END',
  ],
  allRoutes: [],
  languages: [],
  isCreate: true,
  flowName: '',
  flowContextValues: [],
  flowContext: '',
  activeFlows: false,
  sourceId: '',
  jsonData: JSON.stringify(
    {
      flowName: '',
      flowID: '',
      tasks: [{}],
    },
    null,
    2,
  ),
  resetJsonData: false,
  nestLevel: [],
  submit: false,
  validate: false,
};

export const EditFlowReducer = createReducer(
  initialState,
  on(GetFlowsSuccess, (state, { res }) => ({
    ...state,
    flowContextValues: res.payload.data,
  })),
  on(GetLanguagesSuccess, (state, { res }) => ({
    ...state,
    languages: res,
  })),
  on(ViewFlow, EditFlow, (state, { flow }) => ({
    ...state,
    allRoutes: updateRoutes([...state.initialRoutes], flow),
    isCreate: false,
    flowName: flow.flowName,
    flowContext: flow.flowContext,
    activeFlows: !flow.deleteFlag,
    jsonData: JSON.stringify(JSON.parse(flow.flowTask), null, 2),
    resetJsonData: true,
  })),
  on(FlowContextChanged, (state, { flowContext }) => ({
    ...state,
    flowContext: flowContext ?? '',
    validate: false,
  })),
  on(FlowNameChanged, (state, { flowName }) => ({
    ...state,
    flowName,
    validate: false,
  })),
  on(MarkActiveChanged, (state) => ({
    ...state,
    activeFlows: !state.activeFlows,
    validate: false,
  })),
  on(UpdateJsonData, (state, { jsonData, sourceId }) => {
    let disableSave = false;
    let updatedJson = jsonData;

    try {
      updatedJson = JSON.parse(jsonData);
      disableSave = false;
      updatedJson = JSON.stringify(updatedJson, null, 2);
    } catch {
      disableSave = true;
    }
    return {
      ...state,
      jsonData: updatedJson,
      sourceId: sourceId ?? '',
      validate: false,
      allRoutes: disableSave
        ? state.allRoutes
        : updateRoutes([...state.initialRoutes], JSON.parse(jsonData)),
    };
  }),
  on(UpdateJsonDataSimple, (state, { task, key, value, allowableValue }) => {
    let jsonParsed = JSON.parse(state.jsonData);
    const updatedTasks = jsonParsed.tasks.map((jsonTask: any) => {
      if (jsonTask.taskID !== task.taskID) return jsonTask;

      const updatedValue = Number(value) ? Number(value) : value;

      if (allowableValue) {
        return {
          ...jsonTask,
          [key]: {
            ...jsonTask[key],
            [allowableValue]: updatedValue,
          },
        };
      }

      return {
        ...jsonTask,
        [key]: updatedValue,
      };
    });

    jsonParsed.tasks = updatedTasks;
    jsonParsed = JSON.stringify(jsonParsed, null, 2);

    return {
      ...state,
      jsonData: jsonParsed,
      validate: false,
    };
  }),
  on(ResetJsonData, (state) => ({
    ...state,
    jsonData: initialState.jsonData,
    resetJsonData: true,
    validate: false,
    allRoutes: state.initialRoutes,
  })),
  on(ResetClearJsonData, (state) => ({
    ...state,
    resetJsonData: false,
  })),
  on(ValidateJSON, (state) => ({
    ...state,
    submit: true,
  })),
  on(ValidateJSONSuccess, (state) => ({
    ...state,
    validate: true,
  })),
  on(CloseSidenav, (state) => ({
    ...state,
    allRoutes: state.initialRoutes,
    isCreate: true,
    flowName: '',
    flowContext: '',
    activeFlows: false,
    validate: false,
    resetJsonData: true,
    sourceId: '',
    jsonData: JSON.stringify(
      {
        flowName: '',
        flowID: '',
        tasks: [{}],
      },
      null,
      2,
    ),
    submit: false,
  })),
  on(ActiveComponentChanged, (state, { activeComponent }) => {
    if (activeComponent === 'FlowsSearchComponent' || 'FlowConfigurationComponent')
      return {
        ...state,
        allRoutes: state.initialRoutes,
        flowName: '',
        flowContext: '',
        activeFlows: false,
        validate: false,
      };

    return initialState;
  }),
  on(ResetStateFromRouter, () => ({
    ...initialState,
  })),
);

function updateRoutes(initialRoutes: string[], jsonData: any) {
  const json =
    jsonData.hasOwnProperty('tasks') || !jsonData.hasOwnProperty('flowTask')
      ? JSON.stringify(jsonData)
      : jsonData?.flowTask;
  const allRoutes: string[] = initialRoutes;
  JSON.parse(json)?.tasks?.forEach((task: any) => {
    if (!initialRoutes.includes(task.taskID) && !!task?.taskID) {
      allRoutes.push(task.taskID);
    }
  });
  return allRoutes;
}
